import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Signin from "./View/Authentication/Signin";
import ForgotPassword from "./View/Authentication/ForgotPassword";
import ProtectedRoute from "./components/ProtectedRoute";
import FAQ from "./View/Client/FAQ";
import About from "./View/Client/About";
import Contact from "./View/Client/Contact";
import ListArchive from "./View/Client/ListArchive";
import Categoryt from "./View/Client/Category";
import ArchiveDetails from "./View/Client/ArchiveDetails";
import BoardofDirectors from "./View/Client/BoardofDirectors";
import ExecutiveManagement from "./View/Client/ExecutiveManagement";
import ExecutiveManagementDetails from "./View/Client/ExecutiveManagementDetails";
import CategoryDetails from "./View/Client/CategoryDetails";
import BoardofDirectorsDetails from "./View/Client/BoardofDirectorsDetails";
import PassportList from "./View/Client/BodPassport";
import PassportListEMC from "./View/Client/EmcPassport";
import EMCList from "./View/Client/EMCList"
import BODList from "./View/Client/BODList"
function App() {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/signin" component={Signin} />
        <Route exact path="/forgotPassword" component={ForgotPassword} />
        <ProtectedRoute path="/faq" component={FAQ} />
        <ProtectedRoute path="/about" component={About} />
        <ProtectedRoute path="/contact" component={Contact} />
        <ProtectedRoute path="/category" component={Categoryt} />
        <ProtectedRoute path="/listArchive" component={ListArchive} />
        <ProtectedRoute path="/archiveDetails/:id" component={ArchiveDetails} />
        <ProtectedRoute path="/boardofDirectors" component={BoardofDirectors} />
        <ProtectedRoute path="/emcLists" component={EMCList} />
        <ProtectedRoute path="/bodLists" component={BODList} />
        <ProtectedRoute
          path="/board-of-directors/:id"
          component={BoardofDirectorsDetails}
        />
        <ProtectedRoute
          path="/executiveManagement"
          component={ExecutiveManagement}
        />
        <ProtectedRoute
          path="/executiveManagementDetails/:id"
          component={ExecutiveManagementDetails}
        />
        <ProtectedRoute
          path="/categoryDetails/:id"
          component={CategoryDetails}
        />
        <ProtectedRoute
          path="/BoardofDirectorsDetails/:id"
          component={BoardofDirectorsDetails}
        />
        <ProtectedRoute path="/BodPassport"  component={PassportList} />
        <ProtectedRoute path="/EMCPassport" exact component={PassportListEMC} />
        <Route path="/" component={Signin} /> {/* Catch-all route */}
      </Switch>
    </BrowserRouter>
  );
}

export default App;
